import type {
  BetHistoryBet,
  BetHistoryRow,
  CasinoProfitLossBet,
  ParlayBet,
} from '@/types/betReportTypes';

export const isParlayBet = (bet: unknown): bet is ParlayBet => {
  if (!bet || typeof bet !== 'object') return false;

  const row = bet as Partial<ParlayBet>;

  return row.betType === 'parlay' || Array.isArray(row.legs);
};

export const isExchangeBet = (bet: BetHistoryRow): bet is BetHistoryBet =>
  bet.betType === 'exchange' || !isParlayBet(bet);

export const isCasinoProfitLossBet = (bet: unknown): bet is CasinoProfitLossBet => {
  if (!bet || typeof bet !== 'object') return false;

  const row = bet as Partial<CasinoProfitLossBet>;

  return row.betType === 'casino';
};
